import { posthog } from 'src/boot/posthog'
import { log } from 'src/services/app/log.service'

/**
 * PostHog Analytics Composable
 * Simple wrapper for PostHog tracking in auth router
 */
export function usePostHog() {
  const identify = (userId, properties = {}) => {
    posthog.identify(userId, properties)
  }

  function captureEvent(eventName, properties = {}) {
    posthog.capture(eventName, properties)
  }

  /**
   * Capture exception in PostHog with formatted error display.
   *
   * When context.error_name is provided, it becomes the PostHog UI title
   * (Error.message) instead of the raw JS error message. The original error's
   * stack trace is preserved for source map resolution.
   *
   * When context.error_type is provided, it becomes the Error.name prefix
   * shown in PostHog's error tracking UI (e.g. "ApiError", "VueError").
   *
   * @param {Error|*} error - The original error
   * @param {Object} context - Properties sent to PostHog (error_name, error_type, etc.)
   */
  function captureException(error, context = {}) {
    try {
      let errorObj

      if (context.error_name) {
        // Use formatted error_name as PostHog's visual title
        // Preserve original stack for source map resolution
        errorObj = new Error(context.error_name)
        errorObj.stack = error?.stack
        errorObj.cause = error
        if (context.error_type) {
          errorObj.name = context.error_type
        }
      } else {
        errorObj = error instanceof Error ? error : new Error(error?.message || String(error))
      }
      log.error('[POSTHOG] - captureException - reporting error:', errorObj)
      posthog.captureException(errorObj, context)
    } catch (err) {
      // Silently fail if PostHog isn't available
      log.error('[POSTHOG] - captureException - failed to capture exception:', err)
    }
  }

  const reset = () => {
    posthog.reset()
  }

  return {
    identify,
    captureEvent,
    captureException,
    reset,
  }
}
